export class FiscalAssessmentEntryUpdateDocumentsTransformer {
  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      const grouped = Object.entries(errors).reduce<Record<string, Set<string>>>((acc, [key, value]) => {
        const transformedKey = key.startsWith('documents.') ? '_base' : key

        if (!acc[transformedKey]) {
          acc[transformedKey] = new Set()
        }

        value.forEach((message) => acc[transformedKey].add(message))

        return acc
      }, {})

      return Object.entries(grouped).map(([key, messages]) => ({
        [key]: Array.from(messages).join(', '),
      }))
    }
  }
}
